import React from 'react';

import Card from '../../components/Card/Card';
import GqlQueryWrapper from '../../components/GqlQueryWrapper/GqlQueryWrapper';
import Table from '../../components/Table/Table';
import TablePreRender from '../../components/Table/Table.prerender';

import styles from './HistoricalPrices.css';
import { HISTORICAL_PRICES_TABLE } from './queries';
import { HistoricalPricesTableCardUtil } from './util';

const HistoricalPrices = ({ ticker }) => (
    <Card>
        <GqlQueryWrapper
            query={HISTORICAL_PRICES_TABLE}
            variables={{ ticker }}
            dataFunc={HistoricalPricesTableCardUtil}
            placeholder={() => <TablePreRender />}
        >
            {({ data: { data, headers } }) => (
                <React.Fragment>
                    <div className="table-container">
                        <Table
                            data={{ data, headers }}
                            render={(val) => (
                                <div>
                                    <div>{val.price}</div>
                                    <div className="date">{val.date}</div>
                                </div>
                            )}
                            renderLabel={({ label, date }) => (
                                <div>
                                    <div>{label}</div>
                                    {date && (
                                        <div className="date">
                                            As of {date || '-'}
                                        </div>
                                    )}
                                </div>
                            )}
                        />
                    </div>
                </React.Fragment>
            )}
        </GqlQueryWrapper>
        <style jsx>{styles}</style>
    </Card>
);

export default HistoricalPrices;
